import * as S from './BottomSheetHandle.styled';

export const BottomSheetHandle = () => {
    return (
        <S.Wrapper>
            <S.Element />
        </S.Wrapper>
    );
};
